/**
 * @generated SignedSource<<8f69c050044b0a6ebe41753db447ba81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PriceDisplay_item$data = {
  readonly activeHold: {
    readonly displayTimeToExpire: string | null;
  } | null;
  readonly displayPrice: ReadonlyArray<{
    readonly originalConvertedAmountList: ReadonlyArray<{
      readonly currency: Currency | null;
      readonly amount: number | null;
    } | null> | null;
    readonly convertedAmountList: ReadonlyArray<{
      readonly currency: Currency | null;
      readonly amount: number | null;
    } | null> | null;
    readonly privateOfferConvertedAmountList: ReadonlyArray<{
      readonly currency: Currency | null;
      readonly amount: number | null;
    } | null> | null;
    readonly quantityDisplay: string | null;
    readonly percentageOff: string | null;
    readonly textType: string | null;
    readonly amountType: string | null;
    readonly showPriceLabel: boolean | null;
    readonly showPriceVariability: boolean | null;
    readonly offerExpirationDate: string | null;
  } | null> | null;
  readonly " $fragmentType": "PriceDisplay_item";
};
export type PriceDisplay_item$key = {
  readonly " $data"?: PriceDisplay_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceDisplay_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Hold",
      "kind": "LinkedField",
      "name": "activeHold",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayTimeToExpire",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ],
      "concreteType": "ItemDisplayPriceType",
      "kind": "LinkedField",
      "name": "displayPrice",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "originalConvertedAmountList",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "privateOfferConvertedAmountList",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantityDisplay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentageOff",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showPriceLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showPriceVariability",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offerExpirationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "5d8dfba37a6d010f501f07977bac4868";

export default node;
